import { css } from "styled-components";

const buttonStyles = css`
color: #FFFFFF;
background: #EA3939;
`;

export default buttonStyles;
